module.exports = PhotoSwipeLightbox;